module.exports = __webpack_public_path__ + "img/chinesecompany193.f5003f22.png";